/**
 * Legal ID Verification Mock Page
 *
 * A simple wrapper page for the mock LegalIdVerificationMock component.
 * This page is rendered at the /legal-id-verification-mock route.
 */

import { LegalIdVerificationMock } from "../components/legalIdVerificationMock/LegalIdVerificationMock";

export function LegalIdVerificationMockPage() {
  return <LegalIdVerificationMock />;
}
